import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "color", "children"];
import React from 'react';
import pt from 'prop-types';
import { Element } from '../';
import { appendHtmlClass, extendProps, colorPropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var Text = function Text(props) {
  var className = props.className,
    color = props.color,
    children = props.children,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var prefix = getConfig('TEXT_COLOR_PREFIX');
  if (color) {
    if (!Array.isArray(color)) color = "" + prefix + color;else color = color.length > 1 ? "" + prefix + color[0] + "-" + color[1] : "" + prefix + color[0];
    className = appendHtmlClass(className, color);
  }
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: className
  }, rest), children);
};
Object.assign(Text, extendProps(Element, ['align', 'className', 'id', 'children', 'style', 'isAnimated'], {
  /**
   * Text color e.g. "['primary', -2]"
   */
  color: colorPropType.bind(this, false),
  /**
   * Name of HTML element e.g. figcaption or div
   */
  as: pt.oneOf(['span', 'div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'em', 'figcaption', 'address', 'caption', 'dd', 'dt', 'small', 'cite', 'li', 'abbr', 'time', 'q', 'blockquote', 'ul', 'ol', 'dl', 'label', 'kbd'])
}, {
  as: 'span'
}));
export default Text;